import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import './VideoPlayer.css';

const VideoPlayer = ({
  videos, isAnimation = false, animationRadius = null, errorCallback = () => {
    console.log('Video error');
  }, hasFrameThumbnail = false, styleOverride,
}) => {
  const playerRef = useRef(null);

  // Only apply default styles if no styleOverride is provided
  const videoStyles = {
    borderRadius: !isAnimation ? '8px' : animationRadius,
    width: '100%',
    height: 'auto',
    ...((!isAnimation && !styleOverride) && {
      maxHeight: 'calc(80vh - 5rem)',
      objectFit: 'contain',
    }),
    ...styleOverride, // styleOverride takes precedence
  };

  return (
    <div className={`video-player-container${isAnimation ? ' animation' : ''}`}>
      <div ref={playerRef} />
      {(!videos || videos.length === 0) && !isAnimation && (
        <div className="processing-box">Processing Video...</div>
      )}
      {videos && videos.length > 0 && (
        <video
          controls={!isAnimation ? 'controls' : null}
          style={videoStyles}
          poster={!isAnimation && !hasFrameThumbnail ? videos[0].thumbnail : undefined}
          onError={errorCallback}
          autoPlay={!!isAnimation}
          muted={!!isAnimation}
          loop={!!isAnimation}
          playsInline={!!isAnimation}
        >
          {videos.map((video) => (
            <source key={video.uri} src={hasFrameThumbnail ? `${video.uri}#t=0.1` : video.uri} type="video/mp4" />
          ))}
          {!isAnimation ? (
            <track kind="captions" srcLang="en" label="English" />
          ) : null}
        </video>
      )}
    </div>
  );
};

VideoPlayer.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      resolution: PropTypes.string,
      uri: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
  ).isRequired,
  isAnimation: PropTypes.bool,
  animationRadius: PropTypes.string,
  errorCallback: PropTypes.func,
  hasFrameThumbnail: PropTypes.bool,
};


export default VideoPlayer;
